function loadPhotos() {
  const context = require.context("../Assets/Photography", false, /\.(jpe?g|png|webp|gif)$/i);
  return context
    .keys()
    .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
    .map((key) => {
      const imported = context(key);
      return {
        id: key.replace(/^\.\//, ""),
        src: imported.default || imported,
      };
    });
}

export const photos = loadPhotos();
